export default __webpack_public_path__ + "static/media/homeless-pepe.9db32228.jpeg";